interface IProps {
    onClick?: () => void;
    size?: number
    color?: string
}

export const Pending = (props: IProps) => {
    const { onClick, size, color } = props;

    return (
        <svg width={size || 16} height={size || 16} viewBox="0 0 14 14" fill={color || "none"} xmlns="http://www.w3.org/2000/svg">
            <path d="M7.00016 0.333333C3.3335 0.333333 0.333496 3.33333 0.333496 7C0.333496 10.6667 3.3335 13.6667 7.00016 13.6667C10.6668 13.6667 13.6668 10.6667 13.6668 7C13.6668 3.33333 10.6668 0.333333 7.00016 0.333333ZM9.86683 5.4L6.80016 9.4C6.66683 9.53333 6.46683 9.66667 6.26683 9.66667C6.06683 9.66667 5.86683 9.6 5.7335 9.4L4.1335 7.33333C3.9335 7.06667 3.9335 6.6 4.26683 6.4C4.60016 6.2 5.00016 6.2 5.20016 6.53333L6.26683 7.93333L8.80016 4.6C9.00016 4.33333 9.46683 4.26667 9.7335 4.46667C10.0668 4.66667 10.0668 5.06667 9.86683 5.4Z" fill="#ED773A" />
        </svg>

    );
};
